import { User } from '../../models/User';

export const isUserDisabled = (
    user: User | undefined
  ): boolean => {
    return Boolean(
      !user ? true : !user.firstname ? true : !user.lastname ? true : false
    );
  };